
import { defineComponent, computed, PropType, ref, nextTick } from 'vue'

export default defineComponent({
  props: {
    checked: {
      type: Array as PropType<Filter[]>,
      required: true
    }
  },
  setup (props) {
    const text = computed<string>(() => {
      return props.checked.map((filter) => {
        return filter.regexp
      }).join('\n')
    })

    const textarea = ref<HTMLTextAreaElement>()
    const select = () => {
      if (textarea.value) {
        textarea.value.select()
      }
    }

    nextTick(() => {
      if (textarea.value) {
        textarea.value.style.height = `${window.innerHeight}px`
      }
    })

    return {
      text,
      textarea,
      select
    }
  }
})
